import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface CardRootProps extends ComponentProps<'div'> {
  isDisabled?: boolean
  hasError?: boolean
  datatestid?: string
}

function cardRoot({
  className,
  isDisabled = false,
  hasError = false,
  datatestid,
  ...rest
}: CardRootProps) {
  return (
    <div
      data-testid={datatestid}
      className={twMerge(
        'flex w-full cursor-pointer items-center justify-between gap-2 rounded-lg border bg-white p-3 transition-all duration-500 sm:flex-row md:gap-0',
        hasError
          ? 'border-red-500 focus-within:border-red-500 focus-within:ring-4 focus-within:ring-red-100'
          : isDisabled
            ? 'cursor-not-allowed opacity-50'
            : 'hover:border-bios-300 hover:shadow-lg',

        className,
      )}
      {...rest}
    />
  )
}

interface CardDescriptionProps extends ComponentProps<'div'> {}

function cardDescription({ className, ...rest }: CardDescriptionProps) {
  return (
    <div
      className={twMerge(
        'flex w-full min-w-0 flex-1 items-center gap-4 *:text-monochromatic-400',
        className,
      )}
      {...rest}
    />
  )
}

export const InputFileCard = {
  Root: cardRoot,
  Description: cardDescription,
}
